const { REACT_APP_ID_URL } = process.env;

export const idUrl = REACT_APP_ID_URL;
